import { render, staticRenderFns } from "./NewlyArticle.vue?vue&type=template&id=9051ddda&scoped=true&"
import script from "./NewlyArticle.vue?vue&type=script&lang=js&"
export * from "./NewlyArticle.vue?vue&type=script&lang=js&"
import style0 from "./NewlyArticle.vue?vue&type=style&index=0&id=9051ddda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9051ddda",
  null
  
)

export default component.exports